import Vue from 'vue'
import VueRouter from 'vue-router'

import IndexPage from '@/views/index.vue';
import MobileHomePage from '@/views/m/index.vue';

Vue.use(VueRouter)

// 配置路由的数组
const routes = [
	{
		path: '/',
		name: 'IndexPage',
		meta: {
			title: '上海视翰数码科技有限公司'
		},
		component: IndexPage
	},{
		path: '/m',
		name: 'MobileHomePage',
		meta: {
			title: '上海视翰数码科技有限公司'
		},
		component: MobileHomePage
	}
]
// 创建路由对象
const router = new VueRouter({
	mode: 'history', // 使用 history 模式
	routes
})

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next();
});

export default router